<template>
  <!--  自定义抽屉，若不好用后期改用el-drawer-->
  <div>
    <el-drawer
        :title="title"
        v-bind="$attrs"
        v-on="$listeners"
        size="90%"
        :modal-append-to-body="true"
        :append-to-body="true"
    >
      <span slot="title" class="drawer-title">{{ title }}</span>
      <div style="height: 90vh;padding-left: 10px;padding-right: 10px">
        <div>
          <div class="default-table">
            <ApeTable ref="apeTable"
                      :data="tableData"
                      :columns="columns"
                      :loading="loadingStatus"
                      :pagingData="pagingData"
                      @selectList="handleSelectionChange"
                      highlight-current-row
                      height="80vh"
                      border>
              <el-table-column
                  slot="first-column"
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  slot="first-column"
                  width="60"
                  label="序号" align="center">
                <template slot-scope="scope">
                  <span :title="`ID:${scope.row.id}`">{{ offset + scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  slot="second-column"
                  prop="customer_name"
                  label="客户名称"
                  header-align="center"
                  align="left"
                  width="240"
                  :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
              <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                    v-show="scope.row.order_type === 'strike' || scope.row.order_type === '冲账类型'"
              >冲</span>
                  {{ scope.row.customer_name }}
                </template>
              </el-table-column>
              <!--              <el-table-column label="操作" width="80" header-align="center" align="center" fixed="right">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-row>-->
              <!--                    <el-col :span="24">-->
              <!--                      <el-link type="danger" :underline="false" @click="removeRow(scope.row)"><i-->
              <!--                          class="el-icon-delete"/>移除-->
              <!--                      </el-link>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </ApeTable>
          </div>
          <!--        数据统计-->
          <el-row style="text-align: left;margin-bottom: 5px;margin-top: 5px">
            <el-col :span="6">
              <span style="cursor: pointer;font-weight: lighter;font-size: 1rem;font-style: italic">
                共：<span style="color:#1E9FFF;font-size: 1.5rem;font-weight: bold">{{ tableData.length }} </span>条，
                总含税收入：<span class="money" style="color: #1E9FFF;font-size: 1.5rem;font-weight: bold">{{
                  moneyFormat(paymentAccountTotal)
                }}</span>
              </span>
            </el-col>
            <el-col :span="18">
              <div class="box">
                <el-button type="danger" plain @click="removeSelectedRows" size="mini" class="d-flex-row funcbars-default-button"
                           :disabled="this.selectionList.length===0">
                  <i class="el-icon-circle-close"></i>移除选中
                </el-button>
                <el-button @click="clearData" class="d-flex-row funcbars-default-button" size="mini" style="margin-right: 10px">
                  <i class="el-icon-delete"></i>清空数据
                </el-button>
                <ApplyInvoiceOpt :data-list="tableData" @applied="afterOpt"/>
                <MarkOrderInvoiceOpt :data-list="tableData" @marked="afterOpt"/>
                <!--          回款记录-操作按钮和交互窗口-->
                <AdPayRecordOpt :data-list="tableData" :pay_methods="pay_methods" @saveSuccess="afterOpt"/>
                <!--            合同归档-->
                <AdContractOpt :data-list="tableData" @afterContract="afterOpt"/>
                <!--          发票号码-->
                <adInvoicNumber :data-list="tableData" @afterContract="afterOpt"/>
              </div>
            </el-col>
          </el-row>
        </div>

      </div>
    </el-drawer>
  </div>

</template>

<script>
import ApeTable from "@/components/ApeTable";
import { gFunc } from "@/globalFunc";
import MarkOrderInvoiceOpt from "@/views/adOrder/components/MarkOrderInvoiceOpt";
import ApplyInvoiceOpt from "@/views/adOrder/components/ApplyInvoiceOpt";
import AdPayRecordOpt from "@/views/adOrder/components/AdPayRecordOpt";
import AdContractOpt from "@/views/adOrder/components/AdContractOpt";
import adInvoicNumber from '@/views/adOrder/components/adInvoicNumber';

export default {
  name: 'PreviewList',
  components: {
    ApeTable, MarkOrderInvoiceOpt, ApplyInvoiceOpt, AdPayRecordOpt, AdContractOpt,adInvoicNumber
  },
  props: {
    noListenerClass: {
      type: String,
      default: ''
    },
    previewData: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default() {
        return {}
      }
    },
    pay_methods: {
      type: [Array, Object],
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectionList: [], // 列表选中数据
      total: 0, // 总条数
      // 表格数据
      tableData: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      // columns: [],
      loadingStatus: false,
      //合同归档操作相关
      dialogContract: false,
      directDoneInvoiceLoading: false,//标记开票操作
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    title() {
      return `订单数据预览`
    },
    //计算总含税收入
    paymentAccountTotal() {
      let total = 0;
      this.tableData.forEach((row) => {
        total += row.payment_account / 1
      })
      return total
    },
  },
  watch: {
    previewData: {
      handler: function (newVal) {
        if (newVal && newVal.length) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    onOpened() {
      // onOpened
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
    },
    moneyFormat(val) {
      return gFunc.numberFormat(val, 2)
    },
    // 勾选事件
    handleSelectionChange(val) {
      this.selectionList = val
      // this.$emit('handleSelectionChange', val)
    },
    init() {
      if (this.previewData.length) {
        this.tableData = [...this.previewData]
        // 二维数组展开为一维数组
        // this.tableData = [].concat.apply([], this.previewData)
      }
    },
    clearData() {
      this.tableData = []
      this.$emit('clearData')
    },
    removeRow(row) {
      this.tableData.splice(this.tableData.findIndex(item => item.id === row.id), 1)
      this.$emit('removeRow', row)
    },
    removeSelectedRows() {
      this.selectionList.forEach((row) => {
        this.tableData.splice(this.tableData.findIndex(item => item.id === row.id), 1)
      })
      this.$emit('removeSelectedRows', this.selectionList)
    },
    afterOpt() {
      //标记完开票
      this.clearData()
      this.$emit('refresh')
    }
  }
}
</script>

<style>
.drawer-title {
  text-align: left;
  padding-left: 10px;
  font-weight: 900;
  font-size: 1.4rem;
}

.funcbars-default-button {
  padding: 3px 8px;
  /*color: rgb(254, 45, 84);*/
  font-size: 14px;
  /*border: 1px solid rgb(254, 45, 84);*/
  border-radius: 2px;
  cursor: pointer;
}

/*.funcbars-button {*/
/*  !*padding: 0 23px;*!*/
/*  color: rgb(254, 45, 84);*/
/*  font-size: 14px;*/
/*  border: 1px solid rgb(254, 45, 84);*/
/*  border-radius: 2px;*/
/*  cursor: pointer;*/
/*}*/

.funcbars-button {
  padding: 3px 8px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
  flex: 1;
}

.funcbars-button i {
  width: 14px;
  height: 14px;
  font-weight: bold;
  line-height: 1.4;
  margin-right: 5px;
}

.funcbars-button i svg {
  width: 100%;
  height: 100%;
  fill: rgb(254, 45, 84);
}

.box{
  /*border: 1px solid rgb(254, 45, 84);*/
  display: flex;
}
</style>
